import { render, staticRenderFns } from "./AccountDetailsForm.vue?vue&type=template&id=17722450&scoped=true"
import script from "./AccountDetailsForm.vue?vue&type=script&lang=js"
export * from "./AccountDetailsForm.vue?vue&type=script&lang=js"
import style0 from "./AccountDetailsForm.vue?vue&type=style&index=0&id=17722450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17722450",
  null
  
)

export default component.exports